// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__34w14","header":"ClearentDisclaimer_header__2Bb_V","inner":"ClearentDisclaimer_inner__2boGL"};